<template>
	<aside v-if="links" class="faq-category-links">
		<a 
			v-for="(link, key) in links" 
			:key="'link-' + key" 
			:href="link.url" 
			class="text-link--arrow-right" 
			target="_blank">{{ link.title }}</a>
	</aside>
</template>

<script>
export default {
	props: {
		links: {
			type: Array,
			required: true,
		},
	},
	methods: {
		showArticle(id) {
			this.$emit('showPage', id);
		}
	}
};
</script>
